import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Facebook } from 'lucide-react';
import { commonStyles } from '../../styles/common';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className={`${commonStyles.container} py-16`}>
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <h3 className="text-xl font-bold text-white mb-4">CertiFrance</h3>
            <p className="text-sm">
              Expert en Certificats d'Économies d'Énergie (CEE), nous vous accompagnons dans votre transition énergétique.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-white transition-colors">Accueil</a></li>
              <li><a href="/#services" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="/cee" className="hover:text-white transition-colors">Les CEE</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <span>06 12 34 56 78</span>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <span>contact@certifrance.fr</span>
              </li>
              <li className="flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                <span>Grenoble, France</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Suivez-nous</h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/in/guillaume-bray-gte/details/experience/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-white transition-colors"
              >
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; 2024 CertiFrance. Tous droits réservés.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="#" className="hover:text-white transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;